import { Check } from "lucide-react";
import { motion } from "framer-motion";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";

const points = [
  "Mindre forvirring – alt samlet ét sted",
  "Mere retning – værktøjer der hjælper dig videre",
  "Bedre beslutninger – overblik over dine muligheder",
  "Et sabbatår der passer til dig",
];

const AllInOneSection = () => {
  const { ref, isVisible } = useScrollAnimation(0.15);

  return (
    <section className="py-20 md:py-28 bg-background" ref={ref}>
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={isVisible ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-heading md:text-display-sm text-foreground mb-6">
              Alt samlet
              <br />
              <span className="text-accent">ét sted</span>
            </h2>
            <p className="text-lg text-muted-foreground mb-8 max-w-md">
              Slut med at have 15 tabs åbne. MySabbat samler job, rejser, højskole og planlægning — så du slipper for kaos.
            </p>
            <ul className="space-y-4">
              {points.map((point, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: -20 }}
                  animate={isVisible ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.4, delay: 0.2 + i * 0.1 }}
                  className="flex items-start gap-3"
                >
                  <div className="mt-0.5 w-6 h-6 rounded-full bg-accent/15 flex items-center justify-center shrink-0">
                    <Check className="w-3.5 h-3.5 text-accent" />
                  </div>
                  <span className="text-foreground font-medium">{point}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Visual */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={isVisible ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="relative flex justify-center"
          >
            <div className="relative w-[240px] md:w-[280px]">
              {/* Phone */}
              <div className="w-full aspect-[9/18] rounded-[2.5rem] bg-gradient-to-br from-accent/80 to-accent/60 shadow-xl overflow-hidden border-[5px] border-accent/20">
                <div className="absolute inset-[2px] rounded-[2.2rem] bg-gradient-to-b from-background via-background to-muted p-5 pt-10">
                  <div className="h-3 w-16 bg-accent/20 rounded-full mb-3" />
                  <div className="h-4 w-28 bg-foreground/10 rounded-full mb-5" />
                  {[1, 2, 3].map((n) => (
                    <div key={n} className="flex items-center gap-3 p-3 mb-2 rounded-xl bg-card border border-border/40">
                      <div className="w-8 h-8 rounded-lg bg-accent/10" />
                      <div className="flex-1">
                        <div className="h-2.5 w-16 bg-foreground/10 rounded-full mb-1.5" />
                        <div className="h-2 w-24 bg-muted-foreground/10 rounded-full" />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/* Glow */}
              <div className="absolute -inset-10 -z-10 bg-accent/8 rounded-full blur-[60px]" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AllInOneSection;
